import React from 'react';
import Header from './Header';

const SkeletonLoader = () => {
    return (
 <div className="transcribed-consultation-form">
    <Header />
    <div className="mt-0 container">
      <div className="row justify-content-md-center g-3">
        <div className="col-12">
          <div className="w-form fade-in">
            <div className="row g-5">
              <div className="col-12 text-center">
                <div className="skeleton-box" style={{ width: "60%", height: "30px", margin: "0 auto 20px" }}></div>
                <div className="mt-5 p-4">
                  <div className="skeleton-box" style={{ width: "40%", height: "20px", margin: "0 auto 15px" }}></div>
                  <div className="skeleton-box" style={{ width: "80%", height: "16px", margin: "10px auto" }}></div>
                  <div className="skeleton-box" style={{ width: "70%", height: "16px", margin: "10px auto" }}></div>
                  <div className="skeleton-box" style={{ width: "80%", height: "16px", margin: "10px auto" }}></div>
                  <div className="skeleton-box" style={{ width: "200px", height: "40px", margin: "30px auto 0" }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    );
};

export default SkeletonLoader;